(() => {
  'use strict';

  const ATTR_CONTAINER = 'data-newsletter-consent';
  const ATTR_CHECKBOX = '[data-newsletter-consent-checkbox]';
  const ATTR_ERROR = '[data-newsletter-consent-error]';
  const INIT_KEY = 'consentInit';

  function init(container) {
    if (container.dataset[INIT_KEY]) return;
    container.dataset[INIT_KEY] = 'true';

    const checkbox = container.querySelector(ATTR_CHECKBOX);
    const errorEl = container.querySelector(ATTR_ERROR);
    const form = container.closest('form');

    if (!checkbox || !errorEl || !form) return;

    const toggleError = (show) => {
      container.classList.toggle('is-invalid', show);
      checkbox.setAttribute('aria-invalid', show ? 'true' : 'false');
      errorEl.setAttribute('aria-hidden', show ? 'false' : 'true');
    };

    form.addEventListener('submit', (event) => {
      if (checkbox.checked) {
        toggleError(false);
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      toggleError(true);
      checkbox.focus({ preventScroll: true });
      container.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);

    checkbox.addEventListener('change', () => {
      if (checkbox.checked) toggleError(false);
    });
  }

  function initAll() {
    document.querySelectorAll(`[${ATTR_CONTAINER}]`).forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  // Re-init after Shopify section loads (popup, dynamic sections)
  document.addEventListener('shopify:section:load', initAll);
})();
